/* 🤖 this file was generated by script */
export const wsolidiconShare06 = {
  name: 'share_06',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.34 3.14c.29-.36.73-.56 1.2-.55.4 0 .71.21.87.32l.56.46 8.5 7.28.32.3c.1.1.26.28.35.54q.18.51 0 1.02c-.09.26-.24.43-.35.55l-.33.29-8.52 7.3-.53.44c-.16.1-.47.31-.87.32-.47.01-.91-.19-1.2-.55-.26-.31-.3-.68-.32-.87q-.02-.31-.02-.7v-3.1a10.4 10.4 0 0 0-6.23 3.61A1 1 0 0 1 2 19.16v-.6a10.7 10.7 0 0 1 8-10.33V4.7q0-.37.02-.69c.02-.19.06-.56.32-.87" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
